import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, NgZone, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DelegationofauthorityService } from '../../../services/delegationofauthority/delegationofauthority.service';
import { Category } from '../../../interface/delegationofauthority/category';
import { Type } from '../../../interface/delegationofauthority/type';
import { Doatypelist } from '../../../interface/delegationofauthority/doatypelist';
import { RouterModule } from '@angular/router';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { MatProgressSpinner} from '@angular/material/progress-spinner';
import { SharedServices } from '../../../shared/services/shared.services';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { DisplaypageComponent } from '../displaypage/displaypage.component';
import { Overlay } from '@angular/cdk/overlay';

@Component({
  selector: 'app-bydoatype',
  templateUrl: './bydoatype.component.html',
  imports: [CommonModule, FormsModule, RouterModule, MatPaginatorModule, MatTableModule,MatProgressSpinner],
  styleUrls: ['./bydoatype.component.css']
})
export class BydoatypeComponent implements OnInit, AfterViewInit {
  categories: Category[] = [];
  types: Type[] = [];
  filteredTypes: Type[] = [];
  employees: Doatypelist[] = [];
  paginatedEmployees = new MatTableDataSource<Doatypelist>();
  displayedColumns: string[] = ['sno', 'name', 'cai', 'deptName', 'divisionName', 'jobTitle', 'phoneext', 'effectiveDate', 'dollar'];
  selectedCategory: string = '';
  selectedType: string = '';
  selectedOrder: string = 'surname';
  recordsPerPage: number = 10;
  showFields: boolean = false;
  isLoading: boolean = false;
  error: string | null = null;
  shouldSubmitForm: boolean = false;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild('doaCategory') doaCategory!: ElementRef<HTMLSelectElement>;
  @ViewChild('doaTypes') doaTypes!: ElementRef<HTMLSelectElement>;
  @ViewChild('orderBy') orderBy!: ElementRef<HTMLSelectElement>;

  constructor(
    private delegationService: DelegationofauthorityService,
    private sharedService: SharedServices,
    private ngZone: NgZone,
    private dialog: MatDialog,
    private overlay: Overlay
  ) { }

  ngOnInit(): void {
    this.getCategories();
    this.getTypes();
  }

  ngAfterViewInit(): void {
    this.paginatedEmployees.paginator = this.paginator;
    if (this.shouldSubmitForm) {
      this.onSubmit();
    }
  }

  getCategories(): void {
    this.delegationService.getCategories().subscribe(
      (data: Category[]) => {
        this.categories = data;
        if (this.categories.length > 0) {
          this.selectedCategory = this.categories[0].catCode; // Set default category
          this.onCategoryChange();
        }
      },
    );
  }

  getTypes(): void {
    this.delegationService.getTypes().subscribe(
      (data: Type[]) => {
        this.types = data;
        this.onCategoryChange();
      },
    );
  }

  onCategoryChange(): void {
    this.filteredTypes = this.types.filter(type => type.catCode === this.selectedCategory);
  }

  onSubmit(): void {
    if (!this.selectedType) {
        this.sharedService.openModal('Message', 'Please select Doa Types');
        return;
    }
    this.ngZone.run(() => {
        this.isLoading = true;
        this.showFields = true;
    });

    this.delegationService.getEmployees(this.selectedCategory, this.selectedType, this.selectedOrder).subscribe(
        (data: Doatypelist[]) => {
            this.ngZone.run(() => {
                this.isLoading = false;
                if (data && data.length > 0) {
                    data.forEach((item, index) => item.sno = index + 1);
                    this.employees = data;
                    this.paginatedEmployees.data = data;
                    this.paginatedEmployees.paginator = this.paginator;
                    this.error = null;
                } else {
                    this.paginatedEmployees.data = [];
                    this.showFields = false;
                }
            });
        },
        (error) => {
            this.ngZone.run(() => {
                this.error = 'Employees Information Not Found for selected Category and Type';
                this.isLoading = false;
                this.paginatedEmployees.data = [];
                this.showFields = false;
            });
        }
    );
}

  onPageChange(event: PageEvent): void {
    this.recordsPerPage = event.pageSize;
    this.paginatedEmployees.paginator = this.paginator;
  }

  navigateToDisplayPage(employeeNo: string): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '99%';
    dialogConfig.height = '99%';
    dialogConfig.data = { employeeNo };

    const dialogRef = this.dialog.open(DisplaypageComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }

  downloadExcel(): void {
    if (!this.selectedType) {
      this.sharedService.openModal('Message', 'Please select Doa Types');
      return;
    }
    this.delegationService.getDOATypeWorksheet(this.selectedCategory, this.selectedType, this.selectedOrder).subscribe(
      (data: Blob) => {
        const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `DOATypeWorksheet_${new Date().toISOString().slice(0, 19).replace(/:/g, '-')}.xlsx`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      },
      error => {
        console.error('Error downloading the file', error);
      }
    );
  }

 
}